module.exports = __webpack_public_path__ + "img/role6.5ea26575.png";